var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"customers",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Customers")])])],1),_c('CustomerListComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }